// Duenner Wrapper um Radix DropdownMenu, damit Content/Item/Separator
// projektkonsistent gestylt werden.

import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import * as Radix from '@radix-ui/react-dropdown-menu';
import { clsx } from 'clsx';

export const DropdownMenu = Radix.Root;
export const DropdownMenuTrigger = Radix.Trigger;

type ContentProps = ComponentPropsWithoutRef<typeof Radix.Content> & {
  children: ReactNode;
};

export function DropdownMenuContent({ className, children, ...rest }: ContentProps) {
  return (
    <Radix.Portal>
      <Radix.Content
        sideOffset={6}
        align="end"
        // Umklappen, wenn unten kein Platz ist, und Abstand zu den
        // Fensterraendern halten. Waehrend der Einfuehrungstour ist die
        // Seite oft gescrollt; ohne das klappte das Zustands-Menue nach
        // oben in die Sprechblase hinein (B93).
        avoidCollisions
        collisionPadding={16}
        {...rest}
        className={clsx(
          'z-50 min-w-[12rem] rounded-md border border-line bg-cream p-1 shadow-sm',
          'data-[state=open]:animate-in data-[state=closed]:animate-out',
          className
        )}
      >
        {children}
      </Radix.Content>
    </Radix.Portal>
  );
}

type ItemProps = ComponentPropsWithoutRef<typeof Radix.Item> & {
  children: ReactNode;
};

export function DropdownMenuItem({ className, children, ...rest }: ItemProps) {
  return (
    <Radix.Item
      {...rest}
      className={clsx(
        'flex min-h-[44px] cursor-pointer select-none items-center gap-3 rounded px-3 py-2 text-sm text-ink',
        'outline-none data-[highlighted]:bg-cream-dark data-[disabled]:text-ink-faint',
        className
      )}
    >
      {children}
    </Radix.Item>
  );
}

export function DropdownMenuSeparator() {
  return <Radix.Separator className="my-1 h-px bg-line" />;
}

export function DropdownMenuLabel({ children }: { children: ReactNode }) {
  return (
    <Radix.Label className="px-3 py-2 text-xs uppercase tracking-wide text-ink-faint">
      {children}
    </Radix.Label>
  );
}
